import { IntEnumConditions, StringConditions } from '../../../grid/gridFilters/types';

export enum Column {
  OBJECT_TYPE,
  EXCLUDED_ITEMS,
  MODULES,
  REMARKS,
  ACTIONS,
}

export enum ColumnKeys {
  OBJECT_TYPE = 'objectType',
  EXCLUDED_ITEMS = 'excludedItems',
  MODULES = 'modules',
  REMARKS = 'remarks',
  ACTIONS = 'actions',
}

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.OBJECT_TYPE, ColumnKeys.EXCLUDED_ITEMS, ColumnKeys.MODULES];

export interface Filter {
  objectType?: IntEnumConditions;
  excludedItem?: StringConditions;
  modules?: IntEnumConditions;
  remarks?: StringConditions;
}

export enum ObjectType {
  FILE = 1,
  FOLDER = 2,
  FILE_EXTENSION = 3,
  PROCESS = 4,
  FILE_HASH = 5,
  CERTIFICATE_HASH = 6,
  THREAT_NAME = 7,
  CMD_PARAMS = 8,
  IP_MASK = 9,
  CMD_PARAMS_REGEX = 10,
}

export enum Module {
  ON_DEMAND = 1,
  ON_ACCESS = 2,
  ALL = 3,
  ATC_IDS = 4,
  RANSOMWARE_MITIGATION = 6,
  LSASS_PROTECTION = 7,
}

export interface DataGridItem {
  objectType?: ObjectType;
  excludedItems?: string;
  modules?: Array<number>;
  remarks?: string;
  actions?: string;
  id?: string;
  companyId?: string;
  type?: number;
}
export interface ExclusionItemViewData {
  id: string;
  name: string;
  type: string;
  selectedTargets: Array<string>;
  displayedColumns: Array<number>;
  filters: Array<string>;
  compactView: string;
  pageSize: number;
}
export interface ExclusionItemGridData {
  targets: Array<string>;
  isPartner: boolean;
  allColumns: Array<string>;
  views: ExclusionItemViewData;
  defaultViewProps: string;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<DataGridItem>;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface ExclusionItem {
  id: string;
  companyId: string;
  type: number;
  objectType: number;
  excludedItems: string;
  modules: Array<number>;
  remarks: string;
  actions: string;
}
